module.exports = __webpack_public_path__ + "img/avatar-15.6d4860fc.png";